module.exports = __webpack_public_path__ + "img/PMO-presentable.88ef2d5a.png";